import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section id="about" className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        
        {/* Animated About Me Title */}
        <motion.h2
          className="text-4xl md:text-3xl font-extrabold text-center text-gray-900 mb-6 uppercase tracking-wide"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <span className="text-purple-600">A B O U T</span> ME
        </motion.h2>

        <p className="text-center text-gray-600 text-lg mb-8">
          Learn more about my experience, skills, and expertise in data science and technology.
        </p>

        {/* Flex Layout for Better Readability */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Left Side - About Text */}
          <div>
            <h3 className="text-3xl font-semibold text-gray-800 mb-6">
              Get to Know Me!
            </h3>
            <p className="text-gray-700 leading-relaxed">
              I am a <strong className="text-purple-600">Data Science graduate</strong> with a strong background in  
              <strong className="text-purple-600"> Data Analysis, Machine Learning, Cloud Computing</strong>, and  
              <strong className="text-purple-600"> Data Engineering</strong>. With hands-on experience in analyzing  
              large datasets, implementing predictive models, and developing data pipelines, I strive to  
              extract meaningful insights and drive decision-making.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed">
              I have worked on <strong className="text-purple-600">real-world projects</strong> in  
              <strong className="text-purple-600"> finance, housing price prediction, and business intelligence</strong>, 
              using <strong className="text-purple-600">Python, SQL, and Tableau</strong>. I also have experience working with  
              <strong className="text-purple-600"> AWS cloud services (EC2, S3, RDS)</strong> for real-time data processing.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed">
              I actively <strong className="text-purple-600">share my knowledge on LinkedIn</strong>, work on 
              <strong className="text-purple-600"> open-source projects</strong>, and keep learning to stay updated with industry trends.
              I'm currently looking for <strong className="text-purple-600">exciting job opportunities</strong> where I can apply my  
              <strong className="text-purple-600"> technical skills</strong> and <strong className="text-purple-600">business acumen</strong> to solve  
              challenging data problems.
            </p>

            {/* Contact Button */}
            <a
              href="#contact"
              className="inline-block mt-6 px-8 py-3 bg-purple-600 text-white font-semibold text-lg rounded-lg shadow-md hover:bg-purple-700 transition-all"
            >
              Contact Me
            </a>
          </div>

          {/* Right Side - Skills */}
          <div>
            <h3 className="text-3xl font-semibold text-gray-800 mb-6">My Skills</h3>
            <div className="flex flex-wrap gap-3">
              {[
                "Python",
                "SQL",
                "Machine Learning",
                "Data Analysis",
                "Predictive Modeling",
                "Deep Learning",
                "Tableau",
                "Power BI",
                "Data Visualization",
                "AWS (EC2, S3, RDS)",
                "Statistics",
                "Data Engineering",
                "ETL Pipelines",
                "Business Intelligence",
                "Big Data (Hadoop, Hive)",
                "Cloud Computing",
                "GitHub",
                "React",
                "JavaScript"
              ].map((skill, index) => (
                <motion.span
                  key={index}
                  className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold shadow-md"
                  whileHover={{ scale: 1.1 }}
                >
                  {skill}
                </motion.span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;